import { AdminPermission } from '../../../services/commons/Me';
import { AdminPermissions, AdminPermissionsOnModule } from '../../../services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';

export class AreasPermissions {
    public static AREAS_CODE = 'Groups';

    public static Admin: AdminPermissionsOnModule = {};

    public static initializeAreasAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnAreas = AdminPermissions.filter(perms, AreasPermissions.AREAS_CODE);
        AreasPermissions.Admin = AdminPermissions.toAdminModulePermissions(permsOnAreas);
        PermissionsAbilityHelper.logPermissions('Areas', AreasPermissions.Admin);
    };
}
